module.exports = __webpack_public_path__ + "img/write.bc6b8f12.png";